import { inject, Injectable, isDevMode } from '@angular/core';
import { API, Auth } from "aws-amplify";
import { DevAWSSettings, ProdAWSSettings } from "../../../awsconfig";
import { ApiResponse } from 'src/app/shared-models/api-response.model';
import { CognitoUser } from '@aws-amplify/auth';
import { GlobalLeaderboardViewRow, LeaderboardResult, GlobalLeaderboardNewVideosRow, 
  OrgLeaderboardTesRow, OrgLeaderboardNewVideosRow, OrgLeaderboardViewRow, 
  LeaderboardType, GlobalLeaderboardTesRow } from './leaderboard-api-response.model';
import { GetClientResponse } from 'src/app/shared-models/client.model';
import { UsersService } from 'src/app/users/users.service';


@Injectable({
  providedIn: 'root'
})
export class LeaderboardService {

  readonly apiName = "SalesMailUser"
  readonly apiVersion = "2016-04-18";
  readonly awsRegion = "us-east-1";
  public setting = isDevMode() ? new DevAWSSettings() : new ProdAWSSettings();

  private userService = inject(UsersService);

  constructor() { }

  public async getLeaderboardByType(type: LeaderboardType): Promise<ApiResponse<LeaderboardResult>> {
    const path = `/leaderboard?type=${type}`;
    return API.get(this.apiName, path, {});
  }

  // Convenience functions
  public async getGlobalViewsLeaderboard() {
    const result = await this.getLeaderboardByType(1);
    return (result.value as LeaderboardResult).data as GlobalLeaderboardViewRow[];
  }

  public async getGlobalNewVideoLeaderboard() {
    const result = await this.getLeaderboardByType(2);
    return (result.value as LeaderboardResult).data as GlobalLeaderboardNewVideosRow[];
  }

  public async getGlobalTesLeaderboard() {
    const result = await this.getLeaderboardByType(3);
    return (result.value as LeaderboardResult).data as GlobalLeaderboardTesRow[];
  }


  public async getOrgViewsLeaderboard() {
    const result = await this.getLeaderboardByType(4);
    return (result.value as LeaderboardResult).data as OrgLeaderboardViewRow[];
  }

  public async getOrgNewVideoLeaderboard() {
    const result = await this.getLeaderboardByType(5);
    return (result.value as LeaderboardResult).data as OrgLeaderboardNewVideosRow[];
  }

  public async getOrgTesLeaderboard() {
    const result = await this.getLeaderboardByType(6);
    return (result.value as LeaderboardResult).data as OrgLeaderboardTesRow[];
  }

  public async doesUserBelongToOrg():Promise<boolean> {
    const client = await this.userService.getCurrentSalesMailUserClient();

    return client.account_type != 'individual';
  }

  async getCurrentUsersClientId():Promise<number> {
    let user: CognitoUser = await Auth.currentAuthenticatedUser();    

    const getUserPromise = new Promise<number>((resolve, reject) => {
      if(!user) { reject('No user defined'); }
      user.getUserAttributes((err, result) => {
        if (err) {
            console.error(err);
            reject('No client ID');
        }
        let clientId = result.filter(item => item.getName() == "custom:client_id").map(att => att.getValue())[0].toString();
        resolve(Number(clientId));
      });
    });

    return getUserPromise;    
  }




}
